import tokens from '@ifood/pomodoro-tokens';
import { prop } from 'ramda';
import styled from 'styled-components';
import { LayoutProps, SpaceProps, layout, space } from 'styled-system';

type ContainerProps = {
  sidebarWidth: string;
  contentWidth: string;
  maxWidth: string;
};

export const Wrapper = styled.div<ContainerProps & LayoutProps & SpaceProps>`
  display: grid;
  box-sizing: border-box;
  grid-template-columns: ${prop('sidebarWidth')} ${prop('contentWidth')};
  width: 100%;
  max-width: ${prop('maxWidth')};

  @media (max-width: ${tokens.breakpoints.s}) {
    display: flex;
  }
`;

export const Content = styled.div<SpaceProps & LayoutProps>`
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: ${tokens.space.largest};
  width: 100%;

  ${space}
  ${layout}

  @media (max-width: ${tokens.breakpoints.s}) {
    padding-left: unset;
  }
`;
